import { createApp } from "vue";
import App from "./App.vue";
import "./assets/styles/index.css";
import router from "./router";
import store from "./store";
import Toast from "vue-toastification";
import VueFinalModal from "vue-final-modal";
import "vue-toastification/dist/index.css";
import { MotionPlugin } from "@vueuse/motion";
import "sweetalert2/dist/sweetalert2.min.css";
import Maska from "maska";
import { initializeSentry } from "./plugins/sentry";
import { installChunkReloadGuard } from "./utils/chunkReload";

const app = createApp(App);

// Initialize Sentry BEFORE other plugins
// This ensures all Vue errors are captured
initializeSentry(app, router);

// Recover transparently from stale lazy-chunk 404s after a deploy
// (TypeError: Failed to fetch dynamically imported module).
installChunkReloadGuard(router);

app
  .use(store)
  .use(router)
  .use(Toast, {
    position: "bottom-right",
    timeout: 3500,
    transition: "Vue-Toastification__fade",
    maxToasts: 1,
    pauseOnFocusLoss: false,
  })
  .use(VueFinalModal as any)
  .use(MotionPlugin)
  .use(Maska)
  .mount("#app");
